import * as swcHelpers from '@swc/helpers';
import { DataLayer } from '@grandvisionhq/analytics';

const siteFeature = 'newsletter_subscription';
const pushNewsletterEvent = (event)=>{
    var _eventName;
    DataLayer.pushEvent(swcHelpers.objectSpread({
        event: (_eventName = event.eventName) !== null && _eventName !== void 0 ? _eventName : '',
        site_feature: siteFeature,
        interaction_type: event.interactionType
    }, event.optionClicked ? {
        option_clicked: event.optionClicked
    } : null));
};

export { pushNewsletterEvent, siteFeature };
//# sourceMappingURL=newsletter.js.map
